import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITerminal } from "src/models/POS/Terminal.models";

interface TerminalState {
  terminals: ITerminal[];
  terminalToEdit: ITerminal | null;
}

const initialState: TerminalState = {
  terminals: [],
  terminalToEdit: null,
};

const terminalSlice = createSlice({
  name: "Terminal",
  initialState,
  reducers: {
    setTerminalList: (state, action: PayloadAction<ITerminal[]>) => {
      state.terminals = action.payload;
    },
    setTerminalToEdit: (state, action: PayloadAction<ITerminal | null>) => {
      state.terminalToEdit = action.payload;
    },
    concatListTerminal: (
      state: TerminalState,
      action: PayloadAction<ITerminal[]>
    ) => {
      state.terminals = [...state.terminals.concat(action.payload)];
    },
    addTerminal: (state, action: PayloadAction<ITerminal>) => {
      state.terminals.push(action.payload);
    },
    updateTerminal: (state, action: PayloadAction<ITerminal>) => {
      let itemIndex = state.terminals.findIndex(
        item => item.terminalId === action.payload.terminalId
      );
      if (itemIndex !== -1) state.terminals[itemIndex] = action.payload;
    },
    deleteTerminal: (state, action: PayloadAction<number>) => {
      const newArray = state.terminals.filter(
        item => item.terminalId !== action.payload
      );
      state.terminals = newArray;
    },
  },
});

export const {
  setTerminalList,
  concatListTerminal,
  setTerminalToEdit,
  addTerminal,
  updateTerminal,
  deleteTerminal,
} = terminalSlice.actions;

export default terminalSlice.reducer;
